import styled from 'styled-components';

interface IProps {
    src: string;
}

export const BaseImage = styled.div<IProps>`
    background: url('${({ src }) => src}') no-repeat center/cover;
    height: 300px;
`;
